import type {
  MitarbeiterabgleichQuelle,
  MitarbeiterFelder,
} from '../entities/Mitarbeiterabgleich';

const VORNAMEN = ['Eva', 'Jonas', 'Mia', 'Paul', 'Nora', 'Ben', 'Clara'];
const NACHNAMEN = [
  'Klein',
  'Braun',
  'Vogel',
  'Lang',
  'Beck',
  'Frank',
  'Arnold',
];

function mitarbeiter(
  personalnr: string,
  vorname: string,
  nachname: string,
  standort: string | null,
): MitarbeiterFelder {
  return { personalnr, vorname, nachname, standort };
}

const uebereinstimmend = [
  ...Array.from({ length: 41 }, (_, i) => i + 1),
  ...Array.from({ length: 29 }, (_, i) => i + 52),
].map((nr) =>
  mitarbeiter(
    String(nr),
    VORNAMEN[nr % VORNAMEN.length],
    NACHNAMEN[nr % NACHNAMEN.length],
    `ST-${100 + nr}`,
  ),
);

export const MOCK_MITARBEITERABGLEICH_QUELLE: MitarbeiterabgleichQuelle = {
  letzterAbruf: '2026-08-08T12:00:00',
  e2nMitarbeiter: [
    ...uebereinstimmend,
    mitarbeiter('43', 'Lisa', 'Müller', 'ST-207'),
    mitarbeiter('44', 'Markus', 'Schmidt', 'ST-085'),
    mitarbeiter('45', 'Sophie', 'Weber', 'ST-331'),
    mitarbeiter('47', 'Anna', 'Becker', 'ST-263'),
    mitarbeiter('48', 'Felix', 'Hoffmann', 'ST-104'),
    mitarbeiter('49', 'Laura', 'Schulz', 'ST-458'),
    mitarbeiter('51', 'Marie', 'Richter', 'ST-512'),
  ],
  datevMitarbeiter: [
    ...uebereinstimmend,
    mitarbeiter('42', 'Peter', 'Roth', null),
    mitarbeiter('43', 'Lisa', 'Fischer', 'ST-207'),
    mitarbeiter('44', 'Mark', 'Schmidt', 'ST-085'),
    mitarbeiter('45', 'Sophie', 'Web', 'ST-332'),
    mitarbeiter('46', 'Thomas', 'Wagner', null),
    mitarbeiter('47', 'Anna', 'Bäcker', 'ST-263'),
    mitarbeiter('48', 'Felix', 'Hoffmann', 'ST-104'),
    mitarbeiter('49', 'Laura', 'Schulz', 'ST-458'),
    mitarbeiter('50', 'Janina', 'Koch', null),
    mitarbeiter('51', 'Marie', 'Richter', 'ST-512'),
  ],
};
